import Immutable from "immutable";
import moment from "moment/moment";
import * as types from "./constants";
import { defaultChipFilters } from "./components/DownloadCommon";

const initialState = Immutable.fromJS({
  organization: "",
  workarea: "",
  isFetchingSamples: false,
  isFetchingRecordCount: false,
  isFetchingMetaData: false,
  isFetchingPreview: false,
  isFetchingMapData: false,
  isFetchingAutoCompleteTree: false,
  isFetchingDisplayColumns: false,
  isFetchingFile: false,
  sampleMetaData: {},
  autocomplete: {},
  rawHeaders: false,
  previewRowCount: 100,
  preview: [],
  sample: {
    view_name: "",
    display_name: "",
    display_filters: defaultChipFilters
  },
  sampleOptions: [],
  sampleCategoryTree: {},
  recordCount: 0,
  columnNames: [],
  displayColumns: {},
  lastApiQuery: "",
  sampleIDSearch: [],
  dropDownOptionsLoading: false,
  navDrawerChanged: false,

  startDateFilter: "",
  endDateFilter: "",
  advancedFilters: [{ operator: "", value: "", col: "", saved: false }],
  timeZone: "",
  chips: {},

  filteredDownloadData: [],

  showAdvancedSearch: false,
  showTimeZone: false,
  filterChanged: false,
  showGridColumnPicker: true,
  infiniteOffset: 0,
  showPreview: false,
  dropDownOptions: {},
  chipText: {},
  filterOpen: true,
  existingFormText: "{}",
  formHistory: [],
  formEditorUpdated: false
});

function handleAction(state = initialState, action) {
  switch (action.type) {
    case types.DOWNLOAD_CLEAR_SAMPLE_TYPE:
      return state.merge({
        lastApiQuery: "",
        preview: [],
        columnNames: [],
        sample: Immutable.fromJS({
          view_name: "",
          display_name: "",
          display_filters: defaultChipFilters
        }),
        filterChanged: true,
        chipText: Immutable.fromJS({}),
        chips: Immutable.fromJS({}),
        startDateFilter: "",
        showGridColumnPicker: true,
        endDateFilter: "",
        showPreview: false,
        showAdvancedSearch: false,
        showTimeZone: false,
        advancedFilters: [{ operator: "", value: "", col: "", saved: false }],
        timeZone: ""
      });
    case types.DOWNLOAD_SET_SAMPLE_TYPE:
      return state.merge({
        lastApiQuery: "",
        preview: [],
        sample: Immutable.fromJS(
          state
            .get("sampleOptions")
            .toJS()
            .find(s => s.view_name === action.payload)
        ),
        filterChanged: true,
        chipText: Immutable.fromJS({}),
        showGridColumnPicker: true,
        showPreview: false,
        advancedFilters: [{ operator: "", value: "", col: "", saved: false }],
        timeZone: ""
      });
    case types.DOWNLOAD_FILTER_CHANGED:
      return state.set("filterChanged", true);

    case types.DOWNLOAD_SAMPLES_FETCH_REQUEST:
      return state.set("isFetchingSamples", true);

    case types.DOWNLOAD_SAMPLES_FETCH_SUCCESS:
      return state.merge({
        sampleOptions: action.payload.sampleOptionsJSON,
        sampleCategoryTree: action.payload.sampleCategoryTree,
        isFetchingSamples: false
      });

    case types.DOWNLOAD_SAMPLES_FETCH_ERROR:
      return state.set("isFetchingSamples", false);

    case types.DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_REQUEST:
      return state.set("isFetchingAutoCompleteTree", true);

    case types.DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_SUCCESS:
      return state
        .mergeIn(["autocomplete"], {
          [state.get("sample").toJS().view_name]: action.payload
        })
        .merge({
          isFetchingAutoCompleteTree: false
        });
    case types.DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_ERROR:
      return state.set("isFetchingAutoCompleteTree", false);

    case types.DOWNLOAD_TOGGLE_AUTO_PREVIEW:
      return state.set("autoPreview", !state.get("autoPreview"));

    case types.DOWNLOAD_METADATA_FETCH_REQUEST:
      return state.set("isFetchingMetaData", true);

    case types.DOWNLOAD_METADATA_FETCH_SUCCESS:
      return state.merge({
        isFetchingMetaData: false,
        sampleMetaData: Immutable.fromJS(action.payload.sampleMetaData),
        columnNames: Immutable.fromJS(
          Object.keys(action.payload.sampleMetaData)
        )
      });
    case types.DOWNLOAD_METADATA_FETCH_ERROR:
      return state.set("isFetchingMetaData", false);

    case types.DOWNLOAD_RECORD_COUNT_FETCH_REQUEST:
      return state.merge({
        isFetchingRecordCount: true,
        lastApiQuery: action.payload
      });

    case types.DOWNLOAD_RECORD_COUNT_FETCH_SUCCESS:
      return state.merge({
        isFetchingRecordCount: false,
        recordCount: action.payload
      });

    // Search Filters

    case types.DOWNLOAD_TIMEZONE_VALUE:
      return state.set("timeZone", action.payload).set("filterChanged", true);

    case types.DOWNLOAD_SET_START_DATE_FILTER:
      return state.merge({
        startDateFilter: action.payload,
        filterChanged: true
      });

    case types.DOWNLOAD_SET_END_DATE_FILTER:
      return state.merge({
        endDateFilter: action.payload,
        filterChanged: true
      });

    case types.DOWNLOAD_CHIP_SET_TEXT:
      return state.withMutations(s =>
        s
          .setIn(
            ["chipText", action.payload.field],
            Immutable.fromJS(action.payload.text)
          )
          .set("filterChanged", true)
      );

    case types.DOWNLOAD_CHIP_SET:
      return state.withMutations(s =>
        s
          .setIn(
            ["chips", action.payload.field],
            Immutable.fromJS(action.payload.chips)
          )
          .set("filterChanged", true)
      );

    case types.DOWNLOAD_DISPLAY_COLUMNS_REQUEST:
      return state.set("isFetchingDisplayColumns", true);

    case types.DOWNLOAD_DISPLAY_COLUMNS_SUCCESS:
      return state.merge({
        displayColumns: Immutable.fromJS(action.payload),
        isFetchingDisplayColumns: false
      });

    case types.DOWNLOAD_DISPLAY_COLUMNS_ERROR:
      return state.set("isFetchingDisplayColumns", false);

    case types.DOWNLOAD_PREVIEW_FETCH_REQUEST:
      return state.merge({
        filterChanged: false,
        isFetchingPreview: true,
        lastApiQuery: action.payload.lastApiQuery.length
          ? action.payload.lastApiQuery
          : state.get("lastApiQuery")
      });

    case types.DOWNLOAD_PREVIEW_FETCH_SUCCESS:
      return state.withMutations(s => s.set("isFetchingPreview", false));

    case types.DOWNLOAD_PREVIEW_FETCH_ERROR:
      return state.merge({
        isFetchingPreview: false,
        isFetchingRecordCount: false
      });

    case types.DOWNLOAD_MAP_FETCH_REQUEST:
      return state.merge({
        filterChanged: false,
        isFetchingMapData: true,
        lastApiQuery: action.payload.lastApiQuery.length
          ? action.payload.lastApiQuery
          : state.get("lastApiQuery")
      });

    case types.DOWNLOAD_MAP_FETCH_SUCCESS:
      return state.merge({
        isFetchingMapData: false,
        filteredDownloadData: action.payload
      });

    case types.DOWNLOAD_MAP_FETCH_ERROR:
      return state.merge({
        isFetchingMapData: false
      });

    case types.DOWNLOAD_SET_PREVIEW_ROW_COUNT:
      return state.set("previewRowCount", action.payload);

    case types.DOWNLOAD_SET_INFINITE_OFFSET:
      return state.set("infiniteOffset", action.payload);

    case types.DOWNLOAD_SET_SHOW_PREVIEW:
      return state.set("showPreview", action.payload);

    case types.DOWNLOAD_SET_FILTER_OPEN:
      return state.set("filterOpen", action.payload);

    case types.DOWNLOAD_TOGGLE_COLUMN_PICKER:
      return state.set(
        "showGridColumnPicker",
        !state.get("showGridColumnPicker")
      );

    case types.DOWNLOAD_TOGGLE_RAW_HEADERS:
      return state.set("rawHeaders", !state.get("rawHeaders"));
    // return state.set("rawHeaders", action.payload);

    case types.APP_DRAWER_TOGGLE:
      return state.set("navDrawerChanged", true);

    // dropDownOptionsLoading
    case types.DOWNLOAD_AUTOCOMPLETE_FILTER_REQUEST:
      return state.set("dropDownOptionsLoading", true);

    case types.DOWNLOAD_AUTOCOMPLETE_FILTER_SUCCESS:
      return state.merge({
        dropDownOptions: Immutable.fromJS(action.payload.options),
        dropDownOptionsLoading: false,
        recordCount: Number.parseInt(action.payload.count, 10)
      });

    case types.DOWNLOAD_EXCEL_FILE_FETCH_REQUEST:
      return state.merge({ isFetchingFile: true });

    case types.DOWNLOAD_EXCEL_FILE_FETCH_SUCCESS:
    case types.DOWNLOAD_EXCEL_FILE_FETCH_ERROR:
      return state.merge({ isFetchingFile: false });

    case types.DOWNLOAD_SET_SAMPLE_SEARCH:
      return state.merge({
        sampleIDSearch: Immutable.fromJS(action.payload),
        filterChanged: true
      });

    case types.DOWNLOAD_VIEW_CHANGED:
      return state.set("navDrawerChanged", action.payload);

    case types.DOWNLOAD_ADVSEARCH_VALUE:
      return state.withMutations(s =>
        s
          .setIn(
            ["advancedFilters", action.payload.index, "value"],
            action.payload.value
          )
          .setIn(["advancedFilters", action.payload.index, "saved"], false)
      );
    case types.DOWNLOAD_ADVSEARCH_COL:
      return state.withMutations(s =>
        s
          .setIn(
            ["advancedFilters", action.payload.index, "col"],
            action.payload.col
          )
          .setIn(["advancedFilters", action.payload.index, "value"], "")
          .setIn(["advancedFilters", action.payload.index, "operator"], "")
          .setIn(["advancedFilters", action.payload.index, "saved"], false)
      );
    case types.DOWNLOAD_ADVSEARCH_OPERATOR:
      return state.withMutations(s =>
        s
          .setIn(
            ["advancedFilters", action.payload.index, "operator"],
            action.payload.operator
          )
          .setIn(["advancedFilters", action.payload.index, "saved"], false)
      );
    case types.DOWNLOAD_ADVSEARCH_SAVE:
      return state.withMutations(s =>
        s
          .setIn(["advancedFilters", action.payload, "saved"], true)
          .set("filterChanged", true)
      );
    case types.DOWNLOAD_ADVSEARCH_REMOVE:
      if (state.get("advancedFilters").toJS().length === 1) {
        return state.merge({
          advancedFilters: [{ operator: "", value: "", col: "", saved: false }],
          filterChanged: true
        });
      }
      return state.withMutations(s =>
        s
          .removeIn(["advancedFilters", action.payload])
          .set("filterChanged", true)
      );
    case types.DOWNLOAD_ADVSEARCH_ADD:
      return state.set(
        "advancedFilters",
        state.get("advancedFilters").push(
          Immutable.fromJS({
            operator: "",
            value: "",
            col: "",
            saved: false
          })
        )
      );
    case types.DOWNLOAD_TOGGLE_ADVANCED:
      return state.merge({
        showAdvancedSearch: !state.get("showAdvancedSearch"),
        advancedFilters: [{ operator: "", value: "", col: "", saved: false }]
      });
    case types.DOWNLOAD_TOGGLE_TIMEZONE:
      return state.merge({
        showTimeZone: !state.get("showTimeZone"),
        advancedFilters: [{ operator: "", value: "", col: "", saved: false }]
      });
    case types.DOWNLOAD_ADVSEARCH_UPDATE:
      return state.merge({
        showAdvancedSearch: true,
        advancedFilters: action.payload
      });
    case types.FORM_SEARCH_REQUEST_SUCCESS: {
      // eslint-disable-next-line camelcase
      const { last_modified, ...formText } = action.payload;
      return state.merge({
        existingFormText: JSON.stringify(formText, null, 2)
      });
    }
    case types.FORM_HISTORY_REQUEST_SUCCESS: {
      const historyMap = action.payload
        .map(item => {
          // eslint-disable-next-line camelcase
          const { revision_dt, ...formText } = item;
          return {
            revision_dt,
            text: JSON.stringify(formText, null, 2)
          };
        })
        .sort((a, b) => (a.revision_dt > b.revision_dt ? -1 : 1));

      return state.merge({
        formHistory: historyMap
      });
    }
    case types.FORM_CONTENT_CHANGED: {
      return state.merge({
        formEditorUpdated: true
      });
    }
    case types.ACKNOWLEDGE_FORM_CONTENT_CHANGED: {
      return state.merge({
        formEditorUpdated: false
      });
    }
    default:
      return state;
  }
}

function fieldNotNull(value) {
  return !(typeof value === "undefined" || !value);
}

export function updateUrl(state) {
  const paramObj = new URLSearchParams();
  let suffix = 1;
  const validFields = [
    "chips",
    "advancedFilters",
    "sample",
    "startDateFilter",
    "endDateFilter"
  ];

  // eslint-disable-next-line  no-restricted-syntax
  for (const k of Array.from(state.keys()).filter(
    key => validFields.includes(key) && fieldNotNull(state.get(key))
  )) {
    if (k === "advancedFilters") {
      // eslint-disable-next-line  no-restricted-syntax
      for (const obj of Array.from(state.get(k))) {
        if (obj.get("saved") === true) {
          paramObj.append(
            `filter${suffix}`,
            Immutable.fromJS(obj)
              .toString()
              .replace("Map", "")
          );
          suffix += 1;
        }
      }
    } else if (k === "chips") {
      // eslint-disable-next-line  no-restricted-syntax
      for (const [label, obj] of Array.from(state.get(k))) {
        if (obj.size > 0) {
          paramObj.append(label, JSON.stringify(Immutable.fromJS(obj)));
        }
      }
    } else if (k === "sample") {
      paramObj.append("sample", state.get(k).get("view_name"));
    } else if (
      state.get(k) instanceof moment ||
      state.get(k) instanceof Date ||
      state.get(k) instanceof String
    ) {
      paramObj.append(k, state.get(k).format("YYYY-MM-DD"));
    } else if (state.get(k) instanceof Object) {
      paramObj.append(k, Array.from(state.get(k)));
    } else {
      paramObj.append(k, state.get(k));
    }
  }
  const baseUrl = window.location.href.split("?")[0];
  const newUrl = `${baseUrl}?${paramObj.toString()}`;

  if (newUrl !== window.location.href) {
    window.history.pushState({}, "", `${baseUrl}?${paramObj.toString()}`);
  }
}

function downloadReducer(state = initialState, action) {
  const updatedState = handleAction(state, action);

  if (state !== updatedState) {
    updateUrl(updatedState);
  }
  return updatedState;
}

export default downloadReducer;
